export const generateImageSignerPlaceholder = (text: string, subtext: string = '') => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
    const img = new Image();

    img.onload = function () {
        ctx.drawImage(img, 0, 0);
        ctx.drawImage(img, 0, 0, 100, 100);
    };

    ctx.fillStyle = 'rgba(220, 220, 220, 0.37)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.font = '25px Montserrat, sans-serif';
    ctx.fillStyle = 'black';

    ctx.textAlign = 'center';
    ctx.fillText(text, canvas.width / 2, canvas.height / 2);

    // fill text top corner
    ctx.font = '18px Montserrat, sans-serif';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'end';
    ctx.fillText(subtext, canvas.width - 8, canvas.height - 8);

    return canvas.toDataURL('image/png');
};
